import { Aviso } from "../ui";
import {
  respostasDaCondicao,
  fraseDaCondicao,
  type GatilhoDaPergunta,
  type PerguntaDoCatalogo,
} from "../../nucleo/catalogoDoKickoff";

export function CondicaoDaPergunta({ pergunta, perguntas, aoMudar }: {
  pergunta: PerguntaDoCatalogo;
  perguntas: PerguntaDoCatalogo[];
  aoMudar: (gatilho: GatilhoDaPergunta | null) => void;
}) {
  const gatilho = pergunta.visivel_se;
  const candidatas = perguntas.filter(
    (item) => item.id !== pergunta.id && respostasDaCondicao(item).length > 0,
  );
  const origem = candidatas.find((item) => item.id === gatilho?.pergunta_id);
  const simples = !gatilho || (gatilho.operador === "igual" && !gatilho.externo && !!origem);
  const respostas = origem ? respostasDaCondicao(origem) : [];
  const valor = respostas.find((item) => item.valor === gatilho?.valor)?.chave ?? "";

  return (
    <div className="mt-3">
      <label className="campo__moldura">
        <span className="campo__rotulo">Exibir quando</span>
        <select
          className="campo__controle min-h-11"
          value={simples ? gatilho?.pergunta_id ?? "" : "__existente"}
          onChange={(evento) => {
            const nova = candidatas.find((item) => item.id === evento.target.value);
            aoMudar(nova ? {
              pergunta_id: nova.id,
              externo: null,
              operador: "igual",
              valor: respostasDaCondicao(nova)[0]!.valor,
            } : null);
          }}
        >
          <option value="" disabled={pergunta.e_tambem_se.length > 0}>Sempre</option>
          {!simples && <option value="__existente">Manter regra existente</option>}
          {candidatas.map((item) => (
            <option key={item.id} value={item.id}>
              {perguntas.indexOf(item) + 1} · {item.enunciado}
            </option>
          ))}
        </select>
      </label>
      {origem && simples && (
        <label className="campo__moldura">
          <span className="campo__rotulo">Resposta que exibe a pergunta</span>
          <select
            className="campo__controle min-h-11"
            value={valor}
            onChange={(evento) => {
              const resposta = respostas.find((item) => item.chave === evento.target.value);
              if (resposta && gatilho) aoMudar({ ...gatilho, valor: resposta.valor });
            }}
          >
            {!valor && <option value="" disabled>Escolha uma resposta válida</option>}
            {respostas.map((item) => (
              <option key={item.chave} value={item.chave}>{item.rotulo}</option>
            ))}
          </select>
        </label>
      )}
      {gatilho && <p className="nota-rodape">{fraseDaCondicao(gatilho, perguntas)}</p>}
      {!simples && (
        <Aviso tom="atencao">
          Esta regra usa uma condição avançada e será preservada ao salvar.
          Escolher outra pergunta substitui somente esta regra.
        </Aviso>
      )}
      {pergunta.e_tambem_se.length > 0 && (
        <Aviso tom="atencao">
          As condições adicionais também precisam ser atendidas e serão preservadas:
          <ul>
            {pergunta.e_tambem_se.map((item, indice) => (
              <li key={indice}>{fraseDaCondicao(item, perguntas)}</li>
            ))}
          </ul>
        </Aviso>
      )}
    </div>
  );
}
